<ion-tabs
  [ngClass]="{ 'tab-loading': isLoading }"
  (ionTabsWillChange)="onTabChange()"
  (ionTabsDidChange)="onTabChanged()"
>
  <ion-tab-bar
    [hidden]="!showTabBar"
    slot="bottom"
    [translucent]="true"
    [ngClass]="platformReady && currentPlatform === 'ios' ? 'pb-8' : 'pb-5'"
    class="pt-3"
  >
    @for (tab of tabs; track tab) {
      <ion-tab-button
        [tab]="tab.tab"
        [ngClass]="isTabActive(tab.tab) ? (isPrime ? 'prime' : 'non-prime') : ''"
        class="fs-12 area-normal"
      >
        <app-icon
          [name]="isTabActive(tab.tab) ? (isPrime === true ? tab.primeIcon : tab.nonPrimeIcon) : tab.icon"
          size="32"
        ></app-icon>
        <div class="tab__label text-trim-1">
          {{ tab.label | translate }}
        </div>
      </ion-tab-button>
    }
  </ion-tab-bar>
</ion-tabs>
